import React, {useContext} from 'react';
import _get from 'lodash/get.js';
import { StyleSelector } from '../../components/index';
import { NavigationContext } from '../../store/contexts/NavigationContext';
import { AppContext } from '../../store/contexts/AppContext.js';
import { saveUserData } from '../../store/actions/user';
import { login, register } from '../../helpers/SSO.js';
import { constants } from '../../constants';

const { 
	LOCAL_STORAGE_KEYS: { QUIZ, GUEST } 
} = constants

export default function Style() {

   const context = useContext(AppContext);
   const { navigateToActions } = useContext(NavigationContext);
   const { 
		cmsConfiguration, 
		setUserPreferences,
		userPreferences, 
		settings, 
		isUserLoggedIn, 
		setCustomerProfile,
		userToken, 
		setUserToken, 
		setIsUserLoggedIn,
		setActiveView,
		setCanRenderPersonalPage,
		setAllowGuestAccess,
		setGuestExpiryTime,
		setQuizResults    
	} = context;

   const locale = _get(settings, 'locale');
   
   const user = { 
		saveUserData, 
		token:userToken,
		userPreferences, 
		setUserPreferences, 
		locale, 
		isUserLoggedIn, 
		setCustomerProfile, 
		setUserToken, 
		setIsUserLoggedIn,
		setActiveView,
		localStorageKey: QUIZ, 
		localStorageKeyGuestExpiration: GUEST, 
		setCanRenderPersonalPage,
		setAllowGuestAccess,
		setGuestExpiryTime,
		setQuizResults   
	};

	const onClickActions = {
		...navigateToActions,
		'login': () => { 
			setActiveView('style');
			login(setCustomerProfile, setUserToken, setIsUserLoggedIn) },
		'register': () => {
			setActiveView('style'); 
			register() }
	} 

	return (
		<StyleSelector {...{...cmsConfiguration, user, onClickActions}}/>    
	)
}